export default "__VITE_ASSET__3sW_v$wM__"